import React, { useState, useContext } from "react";
import { Link as RouterLink } from "react-router-dom";

import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { versionSystem } from "../../../package.json";
import { i18n } from "../../translate/i18n";
import { nomeEmpresa } from "../../../package.json";
import { AuthContext } from "../../context/Auth/AuthContext";
import logo from "../../assets/logo.png";
import { LanguageOutlined } from "@material-ui/icons";
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import LanguageControl from "../../components/LanguageControl";
import { useTheme } from "@material-ui/styles";

const useStyles = makeStyles(theme => ({
	root: {
		width: "100vw",
		height: "100vh",
		background: theme.palette.loginbackground,
		backgroundRepeat: "no-repeat",
		backgroundSize: "100% 100%",
		backgroundPosition: "center",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		textAlign: "center",
		position: "relative"
	},
	paper: {
		background: theme.palette.login,
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		padding: "55px 30px",
		borderRadius: "12.5px",
		boxShadow: "0px 1px 3px rgba(72, 72, 72, 0.19)"
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: "100%", // Fix IE 11 issue.
		marginTop: theme.spacing(1),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
		textTransform: "capitalize"
	},
	powered: {
		color: "white"
	},
	languageControl: {
		position: "absolute",
		top: 0,
		left: 0,
		paddingLeft: 15,
		paddingTop: 5
	},
	copyright: {
		fontSize: 11,
		color: "white"
	},
	link: {
		textDecoration: "underline",
		color: "white"
	},
	linkSupport: {
		textDecoration: "underline",
		color: theme.palette.textmode
	}
}));

const Copyright = ({ classes }) => {
	return (
		<Typography className={classes.copyright} variant="body2" align="center">
			{"Copyright "}
			<Link className={classes.link} href="https://terabit.com.br/" target="_blank">
				{nomeEmpresa}
			</Link>
			{" - " + new Date().getFullYear()}
			{"."}
			<br />
			<br />
			{i18n.t("login.termText")}
			<Link className={classes.link} href="https://www.terachats.com.br/termos-de-uso/" target="_blank">
				{i18n.t("login.termLink")}
			</Link>
			{i18n.t("login.termAnd")}
			<Link className={classes.link} href="https://www.terachats.com.br/politica-de-privacidade/" target="_blank">
				{i18n.t("login.privacyLink")}
			</Link>
		</Typography>
	);
};

const Login = () => {
	const classes = useStyles();
	const theme = useTheme();
	const [user, setUser] = useState({ email: "", password: "" });

	// Languages
	const [anchorElLanguage, setAnchorElLanguage] = useState(null);
	const [menuLanguageOpen, setMenuLanguageOpen] = useState(false);

	const { handleLogin } = useContext(AuthContext);

	const handleChangeInput = e => {
		setUser({ ...user, [e.target.name]: e.target.value });
	};

	const handlSubmit = e => {
		e.preventDefault();
		handleLogin(user);
	};

	const handlemenuLanguage = (event) => {
		setAnchorElLanguage(event.currentTarget);
		setMenuLanguageOpen(true);
	}

	const handleCloseMenuLanguage = () => {
		setAnchorElLanguage(null);
		setMenuLanguageOpen(false);
	}

	return (
		<div className={classes.root}>
			<div className={classes.languageControl}>
				<IconButton edge="start" onClick={handlemenuLanguage}>
					<LanguageOutlined
						aria-label="account of current user"
						aria-controls="menu-appbar"
						aria-haspopup="true"
						variant="contained"
						style={{ color: "textmode" }}
					/>
				</IconButton>
				<Menu
					id="menu-appbar-language"
					anchorEl={anchorElLanguage}
					getContentAnchorEl={null}
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "right",
					}}
					transformOrigin={{
						vertical: "top",
						horizontal: "right",
					}}
					open={menuLanguageOpen}
					onClose={handleCloseMenuLanguage}
				>
					<MenuItem>
						<LanguageControl />
					</MenuItem>
				</Menu>
			</div>
			<Container component="main" maxWidth="xs">
				<CssBaseline />
				<div className={classes.paper}>
					<div>
						<img style={{ margin: "0 auto", width: "70%" }} src={theme.logo} alt="Whats" />
					</div>
					{/*<Typography component="h1" variant="h5">
					{i18n.t("login.title")}
				</Typography>*/}
					<form className={classes.form} noValidate onSubmit={handlSubmit}>
						<TextField
							variant="outlined"
							margin="normal"
							required
							fullWidth
							id="email"
							label={i18n.t("login.form.email")}
							name="email"
							value={user.email}
							onChange={handleChangeInput}
							autoComplete="email"
							autoFocus
						/>
						<TextField
							variant="outlined"
							margin="normal"
							required
							fullWidth
							name="password"
							label={i18n.t("login.form.password")}
							type="password"
							id="password"
							value={user.password}
							onChange={handleChangeInput}
							autoComplete="current-password"
						/>

						{/* <Grid container justify="flex-end">
					  <Grid item xs={6} style={{ textAlign: "right" }}>
						<Link component={RouterLink} to="/forgetpsw" variant="body2">
						  Esqueceu sua senha?
						</Link>
					  </Grid>
					</Grid>*/}

						<Button
							type="submit"
							fullWidth
							variant="contained"
							color="primary"
							className={classes.submit}
						>
							{i18n.t("login.buttons.submit")}
						</Button>
						{/* { <Grid container>
						<Grid item>
							<Link
								href="#"
								variant="body2"
								component={RouterLink}
								to="/signup"
							>
								{i18n.t("login.buttons.register")}
							</Link>
						</Grid>
					</Grid> } */}
					</form>
					<p>
						{i18n.t("login.help")}
						<Link className={classes.linkSupport} href="https://wa.me/5571996101439" target="_blank">
							{i18n.t("login.helpLink")}
						</Link>.
					</p>
				</div>
				<Box mt={2}><Copyright classes={classes} /></Box>
			</Container>
		</div>
	);
};

export default Login;
